<template>
  <div class="item-card" @click.stop="toggleView">
    <div class="card-content">
      <div class="app-icon-container">
        <img :src="getItemIcon(item.icon)" alt="App Icon" class="app-icon" />
      </div>

      <div class="item-details">
        <div class="app-name">
          {{ item.name }}
          <img
            :src="getStoreImage(item.platformTypeId)"
            alt="Platform Icon"
            class="platform-icon"
          />
        </div>
        <div class="app-description">
          {{ item?.developer?.name || "" }}
        </div>
        <!-- New Card Info Section -->
        <div v-if="isCardInfo" class="card-info">
          <div v-if="item.price" class="info-item price">
            <span class="material-symbols-outlined info-icon ">payments</span>
            <span>{{ item.price }}</span>
          </div>
          <div v-if="item.rate" class="info-item rate">
            <span class="material-symbols-outlined info-icon">star</span>
            <span>{{ item.rate }}</span>
          </div>
          <div v-if="item.size" class="info-item size">
            <span class="material-symbols-outlined info-icon">folder</span>
            <span>{{ item.size }}</span>
          </div>
          <div v-if="item.lastUpdated" class="info-item last-update">
            <span class="material-symbols-outlined info-icon">update</span>
            <span>{{ formatDate(item.lastUpdated) }}</span>
          </div>
          <div v-if="item.releaseDate" class="info-item release-date">
            <span class="material-symbols-outlined info-icon release-date" 
              >calendar_month</span
            >
            <span>{{ formatDate(item.releaseDate) }}</span>
          </div>
        </div>
      </div>
      <div class="platform-icon-container">
        <div
          class="material-icon-wrapper icon"
          v-if="isNotification"
          @click.stop="toggleNotification"
        >
          <template v-if="isNotificationLoading">
            <span class="spinner"></span>
          </template>
          <template v-else>
            <span class="material-symbols-outlined">
              {{
                data.isNotification ? "notifications_active" : "notification_add"
              }}
            </span>
          </template>
        </div>
        <div
          v-if="isOptionMenu"
          class="material-icon-wrapper icon"
          @click.stop="toggleMenu"
        >
          <span class="material-symbols-outlined">more_vert</span>
        </div>
        <OptionsMenu v-if="isMenuOpen" @closeMenu="closeMenu">
          <ButtonComponent
            v-for="button in buttons"
            :key="button.label"
            :label="button.label"
            :icon="button.icon"
            :disable="button.disable"
            :itemId="item.id"
            :action="button.action"
          />
        </OptionsMenu>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/components/custom/buttons/ButtonComponent.vue";
import OptionsMenu from "@/components/custom/dropdown/OptionsMenuComponent.vue";
import { storeImage } from "@/ultis/user/functions/storePlatform";

export default {
  name: "ItemCard",
  components: {
    OptionsMenu,
    ButtonComponent,
  },
  data() {},
  props: {
    data: {
      type: Object,
      required: false,
    },
    item: {
      type: Object,
      required: false,
    },
    menuId: Number,
    buttons: {
      type: Array,
      required: false,
    },
    isNotification: {
      type: Boolean,
      required: false,
    },
    isOptionMenu: {
      type: Boolean,
      required: false,
    },
    isCardInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMenuOpen() {
      return this.menuId === this.data.id;
    },
  },
  methods: {
    getStoreImage(platformTypeId) {
      return storeImage(platformTypeId);
    },
    toggleMenu() {
      this.$emit("setItemMenu", this.data.id);
    },
    closeMenu() {
      this.$emit("setItemMenu", null);
    },
    toggleView() {
      this.$emit("toggleView", this.item.storeId);
    },
    toggleNotification() {
      this.$emit(
        "toggleNotification",
        this.data.itemId,
        this.data.isNotification
      );
    },
    getItemIcon(icon) {
      if (icon) {
        return icon;
      } else {
        return require("@/assets/img/developer/developer.png");
      }
    },
    formatDate(date) {
      if (!date) return "";
      const locale = localStorage.getItem("localeTime") || "en-US";
      return new Date(date).toLocaleDateString(locale);
    },
  },
};
</script>

<style scoped>
/* General card styles */

.item-card {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 25px;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 0 5px #9e9e9e;
  cursor: pointer;
  transition: background-color 0.3s;
  flex: 1 1 calc(23% - 20px);
  position: relative;
}

.item-card:hover {
  background-color: #f4f5fa;
}

/* Flex layout to align icons and details */
.card-content {
  display: flex;
  align-items: center;
}

/* App icon container and styling */
.app-icon-container {
  margin-right: 15px;
}

.app-icon {
  width: 45px;
  height: auto;
  border-radius: 29%;
  user-select: none;
}

/* Item details styling */
.item-details {
  flex: 1;
}

.app-name {
  font-weight: bold;
  font-size: 16px;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-description {
  font-size: 14px;
  color: #555;
}

/* Platform icon and material icon container */
.platform-icon-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
}

/* Material icon for ellipsis */
/* .material-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
} */
.material-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25%;
  padding: 2px;
}

.material-icon-wrapper.icon:hover {
  background-color: rgba(0, 0, 0, 0.1); /* Hover arka plan rengi */
}

.icon span {
  font-size: 20px;
  user-select: none;
}

.platform-icon {
  width: 15px;
  height: auto;
  user-select: none;
}

/* New styles for card info */
.platform-icon-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
}

.material-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25%;
  padding: 2px;
}

.material-icon-wrapper.icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.icon span {
  font-size: 20px;
  user-select: none;
}

.platform-icon {
  width: 15px;
  height: auto;
  user-select: none;
}

@media (max-width: 1200px) {
  .item-card {
    flex: 1 1 calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .item-card {
    flex: 1 1 100%;
  }

  .card-info {
    /* flex-direction: column;
    gap: 4px; */
  }
}
</style>
